import type { JSX } from "react";

export function Footer(): JSX.Element {
    return (
        <div className="w-full flex justify-center items-center pt-8 pb-2">
            <div className="text-sx">
                Copyright © 2025 Qubee. All rights reserved.
            </div>
        </div>
    )
}